export const EMAIL_ALREADY_REGISTERED_MESSAGE =
  'Este e-mail já está cadastrado. Faça login ou use outro e-mail.';

export const isEmailAlreadyRegisteredError = (error: unknown): boolean => {
  if (!(error instanceof Error)) {
    return false;
  }

  return /e-?mail.*(?:cadastrad[oa]|em\s*uso)/i.test(error.message);
};
